import React,{useState,useEffect} from 'react'
import { invokeServices } from '../ServiceCalls/ApiCalls';
import './ServicesComponent.css'

function ServicesComponent() {


    const[services,setServices] = useState([])

    useEffect(() =>{
        
        async function GetData(){
            const services_list = await invokeServices()
            setServices(services_list)
        }
        GetData()
    },[])
  

  return (
    <div>
          <section id="services" >
              <div class="container">
                  <div class="section-header">
                      <h2 class="section-title wow fadeInDown">Whats Best For You</h2>
                      <p class="wow fadeInDown">The modules suit a wide variety of player, from those just picking up a racket for the first time, through to players competing in local and state tournaments.</p>
                  </div>

                  <div className="service-container">
                        <div class="featuresNew">
                            {
                                services.map((s,idx) => <Cards key={idx} service_name = {s.service_name} service_desc={s.service_desc}/>)
                            }
                        </div>
                  </div>
                  
              </div>
          </section>
    </div>
  )
}
const Cards = ({service_name,service_desc}) => {
    return (
        <div class="serviceBox wow fadeInUp" data-wow-duration="300ms" data-wow-delay="0ms">
            <div class="media service-box">
                <div class="pull-left">
                    <i class="fa-solid fa-futbol"></i>
                </div>
                <div class="media-body">
                    <h4 class="media-heading">{service_name}</h4>
                    <p>{service_desc}</p>
                    {/* <p>Boasting six international standard courts, we provide court hire services at one of Melbourne’s premier badminton facilities, Maribyrnong College’s sports academy building.</p> */}
                </div>  
            </div>
        </div>)
}

export default ServicesComponent